export const authRoutes = {
  LOGOUT: "/auth/logout", // GET (новый API)
  AUTH: "/auth/login",
  REG: "/auth/signup",
  CONFIRM_SIGNUP: "/auth/confirm",
  UPDATE_USER: "/user", // PUT (новый API)
  DELETE_USER: "/user", // DELETE (новый API)
  CONFIRM_PHONE: "/user/phone", // POST (новый API)

  BITRIX_REGISTRATION_USER: "/CreateModifyPartner",
}